/*
 * @Author: xieyu7
 * @Date: 2019-04-01 15:43:46
 * @Last Modified by: yincanwei
 * @Last Modified time: 2023-06-19 18:50:51
 */
import request from '../utils/service'
const api = {
  getLoginStates: function(data) {
    return request({
      url: '/driver/v2/api/loginStates',
      method: 'get',
      params: data
    })
  },
  getAds: function(data) {
    return request({
      url: '/publicity/v2/api/advertisings',
      method: 'post',
      data: data
    })
  },
  getNearByParks(data) {
    return request({
      url: '/dealer/v2/api/nearbyParks',
      method: 'post',
      data: data
    })
  },
  getNearByParksHome(data) {
    return request({
      url: '/dealer/v2/api/nearbyParks/home',
      method: 'post',
      data: data
    })
  },
  /* 获取包期规则列表 */
  getBagRuleList(params) {
    return request({
      url: '/special/v2/api/bagMultiRules',
      method: 'get',
      params
    })
  },
  getIndexInfo: function() {
    return request({
      url: '/api/v1/hasRegisteredBerth',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  searchPark: function(data) {
    return request({
      url: '/dealer/v2/api/parksByName',
      method: 'get',
      params: data
    })
  },
  getUserLockList: function() {
    return request({
      url: '/api/v1/getUserLockList',
      method: 'post',
      data: {
        thirdId: localStorage.getItem('openId')
      }
    })
  },
  getBagableParksByLocation: function(data) {
    return request({
      // url: '/dealer/v2/api/nearbyParksPro', 废弃
      url: '/dealer/v2/api/nearbyBagParks',
      method: 'post',
      data: data
    })
  },
  getUserSigned: function(data) {
    return request({
      url: '/driver/v2/api/getDriverIdByThirdId',
      method: 'get',
      params: data
    })
  },
  getBoundVehicleParkingBill: function(data) {
    return request({
      url: '/charge/v2/api/parkOrders/msp/boundVehicleParkingBill',
      method: 'get',
      params: data
    })
  },
  // 校验用户新办理还是续费
  checkRenewable(data) {
    return request({
      url: '/special/v2/api/checkRenewable',
      method: 'post',
      data
    })
  },
  checkIntegral(){
    return request({
      url: '/special/v2/api/diffTimeBook/isAllow',
      method: 'get',
    })
  },
  ssoLogin(data){
    return request({
      url: '/auth/v2/api/driver/loginByToken',
      method: 'post',
      data
    })
  },
  getAppUserId(params){
    return request({
      url: '/driver/v2/api/getThirdIdByDriverId',
      method: 'get',
      params
    })
  }
}

export default api
